import { render, staticRenderFns } from "./LaunchToken.vue?vue&type=template&id=4345733e&"
import script from "./LaunchToken.vue?vue&type=script&lang=js&"
export * from "./LaunchToken.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports